"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _lodash = require("lodash");
var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));
var _accessibility = require("../../constants/accessibility");
var _StyledMenu = _interopRequireDefault(require("./components/StyledMenu"));
var _excluded = ["alignment", "anchorEl", "children", "classes", "className", "dataMetrics", "id", "isBackgroundScrollable", "isNestedMenu", "MenuListProps", "onClose", "open", "subnav", "shouldAutoFocus", "width"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var ALIGNMENT_MAP = Object.freeze({
  "default": Object.freeze({
    left: 'bottom-start',
    right: 'bottom-end'
  }),
  subnav: Object.freeze({
    left: 'right-start',
    right: 'left-start'
  })
});
var popperPlacement = function popperPlacement(isSubNav, alignment) {
  var subnav = isSubNav ? 'subnav' : 'default';
  var alignValue = alignment || 'left';
  return ALIGNMENT_MAP[subnav][alignValue];
};
var defaultProps = {
  alignment: 'left',
  dataMetrics: {
    root: 'fuse_menu'
  },
  isBackgroundScrollable: true,
  MenuListProps: {},
  shouldAutoFocus: true
};

/**
 * Use drop-down menus to let users select an action or options from a set of choices.
 * Typically, drop-down menus are used when you have 5-15 options.
 * If you would like to allow users to select from searchable options inside a form, consider using a single-select or multi-select component instead.
 */
var Menu = /*#__PURE__*/_react["default"].forwardRef(function (_ref, ref) {
  var alignment = _ref.alignment,
    anchorEl = _ref.anchorEl,
    children = _ref.children,
    classes = _ref.classes,
    className = _ref.className,
    dataMetrics = _ref.dataMetrics,
    id = _ref.id,
    isBackgroundScrollable = _ref.isBackgroundScrollable,
    isNestedMenu = _ref.isNestedMenu,
    MenuListProps = _ref.MenuListProps,
    onClose = _ref.onClose,
    open = _ref.open,
    subnav = _ref.subnav,
    shouldAutoFocus = _ref.shouldAutoFocus,
    width = _ref.width,
    rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var inlineStyles = {};
  if (width) {
    inlineStyles.width = width;
  }
  var mergedDataMetrics = _objectSpread({}, defaultProps.dataMetrics, {}, dataMetrics);
  var MenuRef = (0, _react.useRef)(null);
  // Turn this into an array incase it is only one item that has been passed.
  var childrenArray = _react["default"].Children.toArray(children).filter(function (child) {
    return !!child;
  });
  var childrenLength = childrenArray.length - 1;

  // ACCESSIBILITY Menu items can be disabled as well as labels this will ensure the correct menu item is highlighted for accessibility
  var firstEnabledChild = (0, _lodash.findIndex)(childrenArray, function (child) {
    return !child.props.label && !child.props.disabled;
  });

  // ACCESSIBILITY - need to keep track of the disabled indexes so we can't arrow into them
  var disabledIndexes = childrenArray.reduce(function (disabledChildren, child, index) {
    // Don't allow focus on the labels, disabled items or children that are not MenuItems
    if (child.props.label || child.props.disabled || child.type.displayName !== 'MenuItem') {
      disabledChildren.push(index);
    }
    return disabledChildren;
  }, []);

  // ACCESSIBILITY
  var _useState = (0, _react.useState)(firstEnabledChild),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    currentFocused = _useState2[0],
    setCurrentFocused = _useState2[1];
  var _useState3 = (0, _react.useState)(false),
    _useState4 = (0, _slicedToArray2["default"])(_useState3, 2),
    subMenuState = _useState4[0],
    setSubMenuState = _useState4[1]; // setSubMenuState is set by the children on right and left arrow keys
  var _useState5 = (0, _react.useState)(shouldAutoFocus),
    _useState6 = (0, _slicedToArray2["default"])(_useState5, 2),
    enableAutoFocus = _useState6[0],
    setEnableAutoFocus = _useState6[1];
  var correctMenuItemIndex = function correctMenuItemIndex(index) {
    // Return the next index or the first/last menu item
    var nextIndex = index >= 0 ? index : childrenLength;
    if (index > childrenLength) {
      nextIndex = 0;
    }
    return nextIndex;
  };

  // ACCESSIBILITY
  var calculateNextMenuItemIndex = function calculateNextMenuItemIndex(index) {
    var type = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : _accessibility.KEY_DOWN_MAP.ARROW_DOWN;
    var updatedIndex = correctMenuItemIndex(index);
    var isDisabledItem = disabledIndexes.includes(updatedIndex);

    /**
     * If it is a disabled option or a label then increment or decrement the index
     * until you find an item that is enabled.
     *
     */

    while (isDisabledItem) {
      if (_accessibility.KEY_DOWN_MAP.ARROW_UP === type) {
        updatedIndex--;
      } else {
        updatedIndex++;
      }
      updatedIndex = correctMenuItemIndex(updatedIndex);
      isDisabledItem = disabledIndexes.includes(updatedIndex);
    }
    return updatedIndex;
  };
  (0, _react.useEffect)(function () {
    var isItemAvailable = MenuRef.current && MenuRef.current.children && MenuRef.current.children[currentFocused];
    if (isItemAvailable) {
      if (enableAutoFocus) {
        if (open && !subMenuState && MenuRef.current) {
          MenuRef.current.children[currentFocused].focus();
        }
        if (!open) {
          setSubMenuState(false);
          setCurrentFocused(firstEnabledChild);
        }
      } else if (MenuRef.current) {
        // ACCESSIBILITY Remove the active focus if the mouse enter has happened
        MenuRef.current.children[currentFocused].blur();
      }
    }
  }, [open, currentFocused, subMenuState, firstEnabledChild, enableAutoFocus]);
  var changeMenuFocus = function changeMenuFocus(nextIndex, eventType) {
    // ACCESSIBILITY Always keep the current item focused if there is only one item
    if (children.length > 1) {
      setCurrentFocused(calculateNextMenuItemIndex(nextIndex, eventType));
    }
  };
  var childrenWithAccessibility = function childrenWithAccessibility() {
    return (
      /**
       * Cloning the children in order to add the necessary props to handle
       * the keyboard navigation properly
       */
      childrenArray.map(function (child, index) {
        var isMenuItem = child.type.displayName === 'MenuItem';
        var menuItemAdditionalProps = {
          changeMenuFocus: changeMenuFocus,
          currentFocused: currentFocused,
          enableAutoFocus: enableAutoFocus,
          isNestedMenu: isNestedMenu,
          parentId: id,
          setSubMenuState: setSubMenuState
        };
        return /*#__PURE__*/_react["default"].cloneElement(child, _objectSpread({}, isMenuItem && menuItemAdditionalProps, {
          index: index
        }));
      })
    );
  };
  var handleOnKeyDown = function handleOnKeyDown(event) {
    switch (event.key) {
      case _accessibility.KEY_DOWN_MAP.ESCAPE:
      case _accessibility.KEY_DOWN_MAP.TAB:
        {
          event.preventDefault();
          anchorEl.focus();
          onClose(event);
          break;
        }
      default:
        {
          break;
        }
    }
  };
  var handleMouseEnter = function handleMouseEnter() {
    /**
     * Remove the autofocus when using the mouse
     * This will remove the ability to use the keyboard once this has been set
     */
    setEnableAutoFocus(false);
  };
  var handleOnClose = function handleOnClose(event) {
    /**
     * We need to reset the autofocus since the menu stays mounted to the dom
     */
    setEnableAutoFocus(shouldAutoFocus);
    onClose(event);
  };
  var getStyledMenu = function getStyledMenu() {
    return /*#__PURE__*/_react["default"].createElement(_StyledMenu["default"], (0, _extends2["default"])({
      anchorEl: anchorEl,
      classes: classes,
      className: className,
      dataMetrics: {
        root: mergedDataMetrics.root
      },
      onMouseEnter: handleMouseEnter,
      handleOnKeyDown: handleOnKeyDown,
      id: id,
      MenuRef: MenuRef,
      MenuListProps: MenuListProps,
      onClose: handleOnClose,
      open: open,
      popperPlacement: popperPlacement(subnav, alignment),
      subnav: subnav,
      width: width,
      ref: ref
    }, rest), childrenWithAccessibility());
  };
  return isBackgroundScrollable ? getStyledMenu() :
  /*#__PURE__*/
  /*
   * ACCESSIBILITY you must keep `keepMounted, disableAutoFocus, and disableEnforceFocus` on the modal
   * additional accessibility code is located on the menu Item
   */
  _react["default"].createElement(_Modal["default"], {
    open: open,
    BackdropProps: {
      invisible: true
    },
    keepMounted: true,
    "data-metrics": mergedDataMetrics.root,
    disableAutoFocus: true,
    disableEnforceFocus: true
  }, getStyledMenu());
});
Menu.defaultProps = defaultProps;
Menu.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * This controls what side the opened menu aligns itself with the anchor Menu.
   */
  alignment: _propTypes["default"].oneOf(['left', 'right']),
  /**
   * Element to anchor/attach the Menu to. Menu will render underneath the passed anchor element.
   */
  anchorEl: _propTypes["default"].oneOfType([_propTypes["default"].object, _propTypes["default"].func]),
  /**
   * Children are usually MenuItems. They can also include dividers.
   * It is IMPORTANT for accessibility to use MenuItems and do not wrap them in tags.
   * Keyboard functionaly will only work on directly passed MenuItems.
   * `ex: <MenuItem/>Is Acceptable</MenuItem>`
   * DO NOT USE:`<div><MenuItem>This breaks keyboard accessibility</MenuItem>`
   */
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]),
  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](https://v4.mui.com/api/menu/#css) for more details.
   */
  classes: _propTypes["default"].object,
  /**
   * Additional classes to apply to the element.
   */
  className: _propTypes["default"].string,
  /**
   * Override the data-metrics attributes applied to the component.
   */
  dataMetrics: _propTypes["default"].shape({
    root: _propTypes["default"].string
  }),
  /**
   * For accessibility you must pass in an id and add 'aria-controls=ID_NAME' in the element used to open the menu.
   * `(Ex: <button aria-controls="my-popup-menu"></Menu id="my-popup-menu"></Menu>)`
   */
  id: _propTypes["default"].string.isRequired,
  /**
   *  This controls whether the background content is scrollable.
   */
  isBackgroundScrollable: _propTypes["default"].bool,
  /**
   * @ignore
   * Prop is passed in via the menuItem for nested menus only
   */
  isNestedMenu: _propTypes["default"].bool,
  /**
   * Properties applied to the MUI MenuList element. See [MUI MenuList Props](https://v4.mui.com/api/menu-list/#props) for more details.
   */
  MenuListProps: _propTypes["default"].object,
  /**
   * Function callback to invoke when Menu is closed.
   */
  onClose: _propTypes["default"].func.isRequired,
  /**
   * If `true`, Menu will render on the screen.
   * Usually this property is tied to some piece of state or cast the anchorEl as a boolean value: Boolean(anchorEl).
   */
  open: _propTypes["default"].bool.isRequired,
  /**
   * @ignore
   * Prop is passed in via the nested menu item
   * This is  needed to remove the autofocus when the mouse enters
   */
  shouldAutoFocus: _propTypes["default"].bool,
  /**
   * If `true`, the Menu will render as a subnav/nested Menu.
   * The Menu will render left or right of the anchor menu
   * instead of underneath the anchor element.
   */
  subnav: _propTypes["default"].bool,
  /**
   * A Fixed width of Menu in pixels. Ex: `200px`.
   */
  width: _propTypes["default"].string
} : {};
var _default = Menu;
exports["default"] = _default;